import { Typography, makeStyles, TypographyProps, Theme } from '@material-ui/core';
import { typographyColorKeys, getTypographyColor } from 'src/data/colors';

interface StylesProps {
  color: string;
}

const useStylesHeading4 = makeStyles<Theme, StylesProps>((theme: Theme) => ({
  root: {
    fontSize: 26,
    fontWeight: 'normal',
    lineHeight: '31.2px',
    color: ({ color }) => color,
  },
}));

export const Heading4 = ({ children, color, ...props }: headingProps) => {
  const selectedColor = getTypographyColor(color || 'primaryText');
  const classes = useStylesHeading4({ color: selectedColor });

  return (
    <Typography variant="h4" className={classes.root} {...props}>
      {children}
    </Typography>
  );
};

const useStylesHeading5 = makeStyles<Theme, StylesProps>((theme: Theme) => ({
  root: {
    fontSize: 20,
    fontWeight: 'normal',
    lineHeight: '24px',
    color: ({ color }) => color,
  },
}));

type headingProps = Omit<TypographyProps, 'color'> & {
  color?: keyof typeof typographyColorKeys;
};

export const Heading5 = ({ children, color, ...props }: headingProps) => {
  const selectedColor = getTypographyColor(color || 'primaryText');
  const classes = useStylesHeading5({ color: selectedColor });

  return (
    <Typography variant="h5" className={classes.root} {...props}>
      {children}
    </Typography>
  );
};

const useStylesHeading6 = makeStyles<Theme, StylesProps>((theme: Theme) => ({
  root: {
    fontSize: 16,
    fontWeight: 'normal',
    lineHeight: '19.2px',
    color: ({ color }) => color,
  },
}));

export const Heading6 = ({ children, color, ...props }: headingProps) => {
  const selectedColor = getTypographyColor(color || 'primaryText');
  const classes = useStylesHeading6({ color: selectedColor });

  return (
    <Typography variant="h6" className={classes.root} {...props}>
      {children}
    </Typography>
  );
};
